function SpalovacieProcesy(){
    return(
        <div>
            SpalovacieProcesy
        </div>
    );
};

export default SpalovacieProcesy;